import { useEffect, useState, useRef, useCallback } from 'react';
import PdfContent from '../../../../components/pdf-renderer/PdfContent'
import EntryContentRenderer from '../../../../components/pdf-renderer/entry-content-render';
import './pdf-review.css';
import '../../../../components/quiz-form-buttons/quiz-form-buttons.css';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Spin } from 'antd';
import QuizFormButtons from '../../../../components/quiz-form-buttons/quiz-form-buttons';
import { useQuizFormContext } from '../../../../hooks/quiz-form-context';
import RegisterWarnContainer from '../../../../components/register-warn-container/register-warn-container';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import { Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import CongratulationsModel from "../../../../components/CongratulationsModel/CongratulationsModel"
import client from '../../../../utils/contentfulClient';

//RETURN VALUE OBJECT BY INPUTNAME FROM FORMVALUES OBJECT
function getInputValues(inputName, formValuesArr) {
  if (formValuesArr) {
    const inputObject = formValuesArr.find((item) => {
      const key = Object.keys(item)[0];
      return key === inputName;
    });

    return inputObject ? inputObject[Object.keys(inputObject)[0] || 0] : {};
  }
}
function getQuestionValue(data, questionName) {
  if (data && questionName) {
    for (let item of data) {
      for (let key in item) {
        if (item[key]?.questionName === questionName) {
          return item[key]?.value;  // Return the value for the questionName
        }
      }
    }
  }
  return null;  // If no matching questionName is found
}
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const allInputs = [
  'Employee Name',
  'Position',
  'Employee Signature',
  'Date',
  'Manager/Supervisor Name',
  'Date',
  'Manager/Supervisor Signature',
];
const Quiz3Review = ({
  nextPage,
  backPage,
  downloadLinkRef,
  renderQuizReview,
}) => {

  const downloadLink = useRef(null);
  const [contentfullPdfContent, setContentfullPdfContent] = useState([]);
  const [contentfullImageContent, setContentfullImageContent] = useState([]);
  const [formInputs, setFormInputs] = useState({ allFormValData: [], outcome: null });
  const [pdfContent, setPdfContent] = useState([]);
  const [popupText, setPopupText] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('');
  const { isLoggin, formValues, comitteeSectionToShow } = useQuizFormContext();
  const { handbookId } = useParams()
  const [imageUrl, setImageUrl] = useState(getQuestionValue(formValues, 'Company Logo') ? JSON.parse(localStorage.getItem('logoUrl')) : '');
  const startPageRef = useRef(null);
  const navigate = useNavigate()

  const getCurrentDate = () => {
    const currentDate = new Date();
    const currentDateYear = currentDate.getFullYear();
    const currentDateMonth = currentDate.getMonth();
    const currentDateDate = currentDate.getDate();
    const revisionDate = `${monthNames[currentDateMonth]} ${currentDateDate}, ${currentDateYear}`;
    return revisionDate
  }

  //FETCHING CONTENTFUL CONTENT OF STEP3 and SHOW SECTIONS IN CORRECT ORDER
  const fetchContentfulData = async () => {
    try {
      // Fetch pdfDocumentText and imageWithText entries concurrently
      const [entryPdfItems, imageItems, masterPdfItem, popup] = await Promise.all([
        client.getEntries({ content_type: 'pdfDocumentText', include: 10 }),
        client.getEntries({ content_type: 'imageWithText', include: 10 }),
        client.getEntries({ content_type: 'masterPdfReview', include: 10 }),
        client.getEntries({ content_type: 'popup', include: 10 }),
      ]);
      setPopupText(popup?.items[0]?.fields?.popupText)
      // Fetch masterPdfReview entry
      if (masterPdfItem?.items?.length === 0) return;

      const masterPdfReviewEntry = masterPdfItem?.items[0];
      const pdfDocumentSectionOrder = masterPdfReviewEntry?.fields?.pdfDocuments?.map(
        (pdfDocument) => pdfDocument.sys.id,
      );

      // Map pdfDocumentText entries based on the order obtained from masterPdfReview
      const sortedPdfDocumentSection = pdfDocumentSectionOrder?.map(
        (id) => entryPdfItems?.items?.find((item) => item?.sys?.id === id),
      );

      setContentfullImageContent(imageItems?.items);
      setContentfullPdfContent(sortedPdfDocumentSection);

    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  const fetchContentful = useCallback(() => {
    fetchContentfulData();
  }, []);

  const setAllFormData = () => {
    const basicDetails = window.localStorage.getItem('quiz-step1-page1');
    const basicDetailsData = basicDetails
      ? JSON.parse(basicDetails)
      : null;

    const additionalDetails = window.localStorage.getItem('quiz-step2-page1');
    const additionalDetailsData = additionalDetails
      ? JSON.parse(additionalDetails)
      : [];

    const formData = {
      allFormValData: additionalDetailsData,
      outcome: basicDetailsData?.outcome?.outcome,
    };
    if (formData.allFormValData.length > 0) {
      setFormInputs(formData);
    }
    setImageUrl(getQuestionValue(formData?.allFormValData, 'Company Logo') ? JSON.parse(localStorage.getItem('logoUrl')) : '')
  }

  const triggerDownload = () => {
    if (downloadLink.current) {
      downloadLink.current.click();
    }
  };

  useEffect(() => {
    if (downloadLinkRef) {
      downloadLinkRef.current = triggerDownload;
    }
  }, [downloadLinkRef]);

  useEffect(() => {
    if (renderQuizReview) {
      setAllFormData();
    }
  }, [renderQuizReview]);

  function registerToSave() {
    localStorage.setItem("registerToSaveSkipToPage1", true);
    localStorage.setItem('selected-workplace-hazard-backup', localStorage.getItem('selected-workplace-hazard'));
    localStorage.setItem('quiz-step1-page1-backup', localStorage.getItem('quiz-step1-page1'));
    localStorage.setItem('quiz-step2-page1-backup', localStorage.getItem('quiz-step2-page1'));
  }

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 900); // Adjust the breakpoint as needed
  };

  useEffect(() => {
    fetchContentful();
    setAllFormData();
    startPageRef.current.scrollTop = 0;
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //LOGIC TO SHOW SECTION AS PER ITEM OR SECTION REQURMENTS
  const checkSectionRequirementHandler = (item) => {
    let result = false;
    if (item?.fields?.optional === true) {
      if (comitteeSectionToShow === item?.fields?.displaySectionRequirement?.fields?.id) result = true;
      else result = false;
    }
    else {
      result = true;
    }
    return result;
  };
  //MODIFY THE PDF PARATEXT CONTENT those contents(item?.fields?.hasItemListing == true) and Returns getEnteryBlockerLastIndex
  const getEnteryBlockerLastIndex = (item) => {
    const paraTextContentArr = item?.fields?.ParaText?.content;

    if (paraTextContentArr?.length > 0) {
      const modifiedContent = paraTextContentArr?.map((content, index) => {
        content.id = index;
        return content;
      });
      const enteryBlocksItemArr = paraTextContentArr?.filter(
        (content) => content?.nodeType == 'embedded-entry-block',
      );
      return enteryBlocksItemArr[enteryBlocksItemArr?.length - 1]?.id;
    } else {
      return null;
    }
  };

  //LOGIC TO SHOW SECTIONS CONTENT
  const showContentByFormInputs = (item) => {
    const overrideStandardContent = item?.fields?.overrideStandardContent;
    let overRideContent;

    if (overrideStandardContent && overrideStandardContent?.fields?.id) {
      const id = overrideStandardContent.fields.id;
      const fieldValue = getInputValues(id, formInputs.allFormValData)?.value;

      if (item?.fields?.hasItemListing == true) {
        const entryBlockerLastIndex = getEnteryBlockerLastIndex(item);

        if (typeof fieldValue === 'object') {
          fieldValue?.forEach((value) => {
            if (value?.name || value?.description) {
              // Check if the name is already added
              const contentToPuesh = [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [{ type: 'bold' }],
                      value: `${value?.name}`,
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'heading-3',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: `${value?.description}`,
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ];
              // Deep copy of the content array
              const modifiedContent = item?.fields?.ParaText?.content;

              modifiedContent?.splice(entryBlockerLastIndex + 1, 0, ...contentToPuesh);
              item.fields.ParaText.content = modifiedContent;
            }
          });
        }
      } else {
        overRideContent = getInputValues(id, formInputs.allFormValData)?.value;
        item.fields.ParaText.overRideContent = overRideContent;
      }
    }

    return overrideStandardContent ? item?.fields?.ParaText : item?.fields?.ParaText || '';
  };

  //This FUNCTION RETURN JSX WILL BE SHOW IN DOWNLOADED PDF
  const generatePdfContent = (
    contentfullPdfContent,
  ) => {
    return contentfullPdfContent?.length > 0 ? (
      contentfullPdfContent
        ?.filter((item) => checkSectionRequirementHandler(item))
        ?.map((item, index) => (
          <div className="section-bottom-blue-line">
            <EntryContentRenderer
              businessName={getInputValues('1', formInputs.allFormValData)?.value}
              contentId={item.sys.id}
              paraTextContent={showContentByFormInputs(item)}
              imageItems={contentfullImageContent}
              formValData={formInputs?.allFormValData}
              allContent={item}
              key={index}
            />
          </div>
        ))
    ) : (
      <p>No Entries Found</p>
    );
  };
  const renderDesktopSidebar = () => {
    return (<div className="quiz-review-sidebar-container">
      {contentfullPdfContent.length > 0 ? (
        contentfullPdfContent?.map((item, index) => {
          const activeClass = index === 0 ? 'active' : '';
          if (checkSectionRequirementHandler(item)) {
            return (
              <a
                className={`quiz-review-sidebar-wrapper ${activeClass}`}
                key={item?.sys?.id}
                href={`#${item?.sys?.id}`}
              >
                <div className="quiz-review-sidebar-item">{item?.fields?.name}</div>
              </a>
            );
          }
        })
      ) : (
        <Spin size="large" />
      )}

      <a className="quiz-review-sidebar-wrapper " href="#form-review-page">
        <div className="quiz-review-sidebar-item">Employee Handbook Sign-Off</div>
      </a>
    </div>)
  }

  //LOGIC TO SIDE BAR FOR MOBILE VIEW
  const redirectToAnchor = (anchor) => {
    window.location.hash = anchor;
  }
  const handleMenuClick = (e) => {
    const menuItems = getMenuItems();
    const selectedItem = menuItems?.find(item => item.key === e.key);
    setSelectedLabel(selectedItem?.label);
    redirectToAnchor(e.key)
  };
  const getMenuItems = () => {
    let items = contentfullPdfContent
      .filter((item, index) => checkSectionRequirementHandler(item))
      .map((item, index) => ({
        label: item?.fields?.name,
        key: `#${item?.sys?.id}`,
      }))
    items.push({
      label: "Employee Handbook Sign-Off",
      key: "#form-review-page"
    })
    return items
  }
  const renderSidebarDropdown = () => {
    const menuItems = getMenuItems();
    const menuProps = {
      items: menuItems,
      onClick: handleMenuClick,
      defaultSelectedKeys: [menuItems[0]?.key]
    };
    return (
      <div className="mobile-sidebar-container">
        <Space wrap className='mobile-sidebar-dropdown' style={{ width: '100%', height: '50%' }}>
          <Dropdown menu={menuProps} placement='bottom' size='large'>
            <div className="selection-container" >
              <div className="selecte-text-container">
                <spam className="selected-text">{selectedLabel == '' ? menuItems[0]?.label : selectedLabel}</spam>
              </div>
              <DownOutlined />
            </div>
          </Dropdown>
        </Space>
      </div>
    )
  }

  const renderSignoffPage = (businessName) => {
    return (<div className="static-page" id="form-review-page">
      <h2>Employee Handbook Sign-Off</h2>
      <p>
        I acknowledge receipt of the <b>{businessName}</b> Occupational Health & Safety Employee
        Handbook on:
      </p>
      <div className="dates">
        <input className="day" /> (Day) <input className="month" /> (Month),{' '}
        <input className="year" /> (Year)
      </div>
      <p>
        I have reviewed the Handbook in its entirety and understand my responsibilities as
        an employee for managing health and safety in the workplace.  When necessary, I have
        asked my supervisor/manager for clarification of my roles and responsibilities.
      </p>
      <p>
        I acknowledge that workplace health and safety is a shared responsibility between
        employers, supervisors and employees and agree to adhere to all {businessName} policies,
        procedures and safe work practices.
      </p>
      <div className="inputSection">
        {allInputs?.map((input) => {
          return (
            <div className="input" key={input}>
              <div className="label">{input}</div>
              <input />
            </div>
          );
        })}
      </div>
      <b>Signed copy to be kept in employee file.</b>
    </div>)
  }
  const downloadPdf = () => {
    downloadLink.current?.click();
  }
  async function saveFormValuesToDB(formValues) {
    let formValuesWithCompletedDate = formValues;
    let isFoundCompletedDate = false;
    for (let i = 0; i < formValuesWithCompletedDate.length; i++) {
      if (formValuesWithCompletedDate[i].completedDate) {
        // Add new completed date
        formValuesWithCompletedDate[i].completedDate = new Date().getTime();
        isFoundCompletedDate = true;
      }
    }
    if (!isFoundCompletedDate) {
      // add in completed date if none is found
      formValuesWithCompletedDate = [...formValues, { completedDate: new Date().getTime() }];
    }

    try {
      let endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/`;
      if (handbookId) {
        endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/${handbookId}`;
      }
      const token = JSON.parse(localStorage.getItem('loginToken'));
      // Convert the formValues array to a JSON string
      const requestBody = handbookId
        ? JSON.stringify({
          _id: handbookId,
          basicDetails: JSON.parse(localStorage.getItem("quiz-step1-page1")),
          additionalDetails: formValuesWithCompletedDate,
        })
        : JSON.stringify({
          basicDetails: JSON.parse(localStorage.getItem("quiz-step1-page1")),
          additionalDetails: formValuesWithCompletedDate,
        });

      // Make the HTTP POST request using Axios
      const response = await axios({
        method: handbookId ? 'PUT' : 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: requestBody,
      });

      return response?.data;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async function saveFormData() {
    let handBookSave;
    if (JSON.parse(localStorage.getItem("loginToken"))) {
      handBookSave = await saveFormValuesToDB(formValues);
    }
    if (!handbookId) {
      navigate(`/safety-orientation-handbook/quiz/${handBookSave?.jsonBody?.handbookResult?.id}`)
    }
    return handBookSave ? true : false;
  }
  useEffect(() => {
    const pdf = generatePdfContent(contentfullPdfContent);
    setPdfContent(pdf);

  }, [contentfullPdfContent]);

  // Save content if logged in and is part of an existing handbook
  useEffect(() => {
    if (handbookId) {
      saveFormData();
    }
  }, []);



  return (
    <>
      <div className="quiz-review-container" ref={startPageRef}>
        <div className="quiz-review-wrapper">
          {
            !isMobile && <>{renderDesktopSidebar()}</>
          }
          <div className="quiz-review-pdf-container">
            <div className="quiz-review-pdf-title-container">
              <div className="quiz-review-pdf-title-wrapper">
                <div className="quiz-review-pdf-title">Review & Download</div>
              </div>
              {
                !isLoggin &&
                <RegisterWarnContainer registerToSave={() => registerToSave()} />
              }
            </div>
            {
              isMobile && <>{renderSidebarDropdown()}</>
            }
            <div className="pdf-wrapper">
              <div className="pdf-review-cover-section" id="45Hnzzea9fBR4S5m2q5DHY">
                <div className="b11">
                  {imageUrl && <img style={{ width: 200, height: 200 }} src={imageUrl} />}
                  <div className="b22">{getInputValues('1', formInputs.allFormValData)?.value}</div>
                  <div className="b33">Employee Health &amp; Safety Handbook</div>
                  <div className="b44">Revision Date: {getCurrentDate()}</div>
                </div>
              </div>
              {pdfContent}
            </div>
            {renderSignoffPage(getInputValues('1', formInputs.allFormValData)?.value)}

          </div>
          <QuizFormButtons
            pageType={'Quiz3Review'}
            nextPageClick={() => { }}
            backPageClick={() => backPage()}
            registerToSave={() => registerToSave()}
            downloadPdf={downloadPdf}
            resetFormData={() => { }}
            isLoggin={isLoggin}
            saveFormData={saveFormData}
          />

          <PDFDownloadLink
            document={
              <PdfContent
                pdfContent={pdfContent}
                revisionDate={getCurrentDate()}
                businessName={getInputValues('1', formInputs.allFormValData)?.value}
                imageUrl={imageUrl}
              />
            }
            fileName="Employee_Health_And_Safety_Handbook.pdf"
          >
            {({ loading }) =>
              loading ? (
                'Loading document...'
              ) : (
                <button style={{ display: 'none' }} ref={downloadLink}>
                  Download now!
                </button>
              )
            }
          </PDFDownloadLink>
        </div>
        <CongratulationsModel description={popupText} />
      </div>
    </>
  );
};

export default Quiz3Review;
